import {Component, Input, Output, OnInit, SimpleChanges, EventEmitter} from '@angular/core';
import {DropdownMenuOption} from './../../../models/dropdown-menu-option';

@Component({
    selector: 'app-dropdown-menu',
    templateUrl: './dropdown-menu.component.html',
    styleUrls: ['./dropdown-menu.component.scss']
})
export class DropdownMenuComponent implements OnInit {
    @Input() iconName: string;
    @Input() options: Array<DropdownMenuOption>;
    @Input() selected: DropdownMenuOption;
    @Input() extraInfo: string;
    @Output() select: EventEmitter<string> = new EventEmitter();
    public edit: boolean = false;
    constructor() {}

    onSelectOption(item): void {
        this.select.emit(item);
    }

    ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/components/dropdown-menu/dropdown-menu.component.ts